<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <p-dropdown [options]="orderProducts"
              formControlName="orderProductId" id="orderProductId"
              optionLabel="name"
              optionValue="orderProductId" [filter]="true" filterBy="name" [showClear]="false"
              placeholder="Select Order Product"
              [disabled]="isUpdate"

              (onChange)="onProductSelect($event)">
            </p-dropdown>
            <label for="orderProductId"> Product</label>
            @for (validation of validationMessages.orderProductId; track validation) {
              <span>
                @if (form1.get('orderProductId').hasError(validation.type) && (form1.get('orderProductId').dirty || form1.get('orderProductId').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-3">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="ownerStmtId" id="ownerStmtId" type="number" readonly="true" pInputText >
            <label for="ownerStmtId">Owner Stmt Id</label>
          </span>
        </div>
        @if (type==='Expense') {
          <div class="col-lg-3">
            <span class="p-float-label required-field w-100 mb-3">
              <input formControlName="ownerStmtExpId" id="ownerStmtExpId" type="number" readonly="true" pInputText >
              <label for="ownerStmtExpId">Statement Expense Id</label>
            </span>
          </div>
        }
        @if (type==='Reservation') {
          <div class="col-lg-3">
            <span class="p-float-label required-field w-100 mb-3">
              <input formControlName="ownerStmtRezId" id="ownerStmtRezId" type="number" readonly="true" pInputText >
              <label for="ownerStmtExpId">Statement Reservation Id</label>
            </span>
          </div>
        }
        <!-- <div class="col-lg-3">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="reservationId" id="orderId" type="number" readonly="true" pInputText >
          <label for="orderId">Order Id</label>
        </span>
      </div>-->

      <!--
      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <p-dropdown [options]="beds" formControlName="bedId" id="bedId" optionLabel="name"
            optionValue="bedId" [filter]="true" filterBy="name" [showClear]="false"
            placeholder="Select Bed">
          </p-dropdown>
          <label for="bedId">Bed</label>
          <span *ngFor="let validation of validationMessages.bedId">
            <small class="p-invalid"
              *ngIf="form1.get('bedId').hasError(validation.type) && (form1.get('bedId').dirty || form1.get('bedId').touched)">{{validation.message}}
            </small>
          </span>
        </span>
      </div>
      -->

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="quantity" id="quantity" type="number" pInputText>
          <label for="quantity">quantity</label>
          @for (validation of validationMessages.quantity; track validation) {
            <span>
              @if (form1.get('quantity').hasError(validation.type) && (form1.get('quantity').dirty || form1.get('quantity').touched)) {
                <small id="name2-help" class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="amount" id="amount" type="number" pInputText>
          <label for="amount">Amount</label>
          @for (validation of validationMessages.amount; track validation) {
            <span>
              @if (form1.get('amount').hasError(validation.type) && (form1.get('amount').dirty || form1.get('amount').touched)) {
                <small id="name2-help" class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <!--<div class="col-lg-6">
      <span class="p-float-label required-field w-100 mb-3">
        <input formControlName="listPriceAdjustmentPercent" id="listPriceAdjustmentPercent" type="number" pInputText>
        <label for="listPriceAdjustmentPercent">List Price Adjustment Percent</label>
        <span *ngFor="let validation of validationMessages.listPriceAdjustmentPercent">
          <small id="name2-help" class="p-invalid"
            *ngIf="form1.get('listPriceAdjustmentPercent').hasError(validation.type) && (form1.get('listPriceAdjustmentPercent').dirty || form1.get('listPriceAdjustmentPercent').touched)">{{validation.message}}
          </small>
        </span>
      </span>
    </div>

    <div class="col-lg-6">
      <span class="p-float-label required-field w-100 mb-3">
        <input formControlName="listPriceAdjustmentAmount" id="listPriceAdjustmentAmount" type="number" pInputText>
        <label for="listPriceAdjustmentAmount">List Price Adjustment Amount</label>
        <span *ngFor="let validation of validationMessages.listPriceAdjustmentAmount">
          <small id="name2-help" class="p-invalid"
            *ngIf="form1.get('listPriceAdjustmentAmount').hasError(validation.type) && (form1.get('listPriceAdjustmentAmount').dirty || form1.get('listPriceAdjustmentAmount').touched)">{{validation.message}}
          </small>
        </span>
      </span>
    </div>-->

    <!--<div class="col-lg-6">
    <span class="p-float-label w-100 mb-3">
      <textarea formControlName="name" id="name" [rows]="2" pInputTextarea ></textarea>
      <label for="name">Name</label>
      <span *ngFor="let validation of validationMessages.name">
        <small class="p-invalid"
          *ngIf="form1.get('name').hasError(validation.type) && (form1.get('name').dirty || form1.get('name').touched)">{{validation.message}}
        </small>
      </span>
    </span>
  </div>-->

  <div class="col-lg-6">
    <span class="p-float-label w-100 mb-3">
      <textarea formControlName="description" id="description" [rows]="2" pInputTextarea></textarea>
      <label for="description">Description</label>
      @for (validation of validationMessages.description; track validation) {
        <span>
          @if (form1.get('description').hasError(validation.type) && (form1.get('description').dirty || form1.get('privateNotes').touched)) {
            <small class="p-invalid"
              >{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>

  @if (type==='Expense') {
    <div class="col-lg-6">
      <span class="p-float-label w-100 mb-3">
        <p-calendar formControlName="serviceDate" inputId="serviceDate" appendTo="body">
        </p-calendar>
        <label for="serviceDate">Service Date</label>
        @for (validation of validationMessages.serviceDate; track validation) {
          <span>
            @if (form1.get('serviceDate').hasError(validation.type) && (form1.get('serviceDate').dirty || form1.get('serviceDate').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>
  }

  <!--<div class="col-lg-6">
  <span class="p-float-label w-100 mb-3">
    <textarea formControlName="publicNotes" id="publicNotes" [rows]="2" pInputTextarea></textarea>
    <label for="publicNotes">Public Notes</label>
    <span *ngFor="let validation of validationMessages.publicNotes">
      <small class="p-invalid"
        *ngIf="form1.get('publicNotes').hasError(validation.type) && (form1.get('publicNotes').dirty || form1.get('publicNotes').touched)">{{validation.message}}
      </small>
    </span>
  </span>
</div>

<div class="col-lg-6">
  <span class="p-float-label w-100 mb-3">
    <textarea formControlName="changeLog" id="changeLog" [rows]="2" pInputTextarea></textarea>
    <label for="changeLog">Change Log</label>
    <span *ngFor="let validation of validationMessages.changeLog">
      <small class="p-invalid"
        *ngIf="form1.get('changeLog').hasError(validation.type) && (form1.get('changeLog').dirty || form1.get('changeLog').touched)">{{validation.message}}
      </small>
    </span>
  </span>
</div>-->

<!--<div class="col-lg-12">
<span class="p-float-label w-100 mb-3">
  <textarea formControlName="guestNotes" id="guestNotes" [rows]="2" pInputTextarea></textarea>
  <label for="guestNotes">Guest Notes</label>
  <span *ngFor="let validation of validationMessages.guestNotes">
    <small class="p-invalid"
      *ngIf="form1.get('guestNotes').hasError(validation.type) && (form1.get('guestNotes').dirty || form1.get('guestNotes').touched)">{{validation.message}}
    </small>
  </span>
</span>
</div>-->
<!--
<div class="col-lg-6">
  <h6 for="salesTaxable">Sales Taxable Options</h6>
  <div class="flex align-items-center">
    <p-checkbox [formControl]="form1.controls['salesTaxable']" inputId="salesTaxable" [binary]="true"></p-checkbox>
    <span class="orderDetail-nm">Sales Taxable?</span>
  </div>
  <span *ngFor="let validation of validationMessages.salesTaxable">
    <small class="p-invalid"
      *ngIf="form1.get('salesTaxable').hasError(validation.type) && (form1.get('salesTaxable').dirty || form1.get('salesTaxable').touched)">{{validation.message}}
    </small>
  </span>
</div>

<div class="col-lg-6">
  <h6 for="roomTaxable">Room Taxable Options</h6>
  <div class="flex align-items-center">
    <p-checkbox [formControl]="form1.controls['roomTaxable']" inputId="roomTaxable" [binary]="true"></p-checkbox>
    <span class="orderDetail-nm">Room Taxable?</span>
  </div>
  <span *ngFor="let validation of validationMessages.roomTaxable">
    <small class="p-invalid"
      *ngIf="form1.get('roomTaxable').hasError(validation.type) && (form1.get('roomTaxable').dirty || form1.get('roomTaxable').touched)">{{validation.message}}
    </small>
  </span>
</div>
-->
</div>
</div>
<hr>
  <div class="row m-0">
    <div class="col-lg-12">
      <div class="btn-group">
        <div class="button-group">
          @if (objToEdit) {
            <button pButton class="btn-delete p-button-outlined p-button-danger"
            (click)="onFormDelete()">Delete {{type}}</button>
          }
        </div>

        <div class="button-group">
          <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
          @if (!objToEdit) {
            <button pButton class="btn-addt p-button" (click)="formAdd()">Add {{type}} Detail</button>
          }

          @if (objToEdit) {
            <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update {{type}} Detail</button>
          }
        </div>
      </div>
    </div>
  </div>
</div>
